// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"styles_placeholder__Vwg3Y","r100":"styles_r100__UXqN3","r50":"styles_r50__OfN09","r56":"styles_r56__T4q_9"};